import clsx from "clsx";

//#region Types
interface SpinnerLoadingProps {
  colorClass?: string;
}
//#endregion

const SpinnerLoading = ({ colorClass = "" }: SpinnerLoadingProps) => {
  return <span className={clsx("loading loading-spinner loading-sm", colorClass)} />;
};

export default SpinnerLoading;
